module.exports = __webpack_public_path__ + "static/media/stream_display_img.fe76fe40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stream_display_img.jpg
// module id = 2474
// module chunks = 7